import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import uiControll from '@/store/uiControll'
import getCsrfToken from '@/store/Csrf'
import { commonUtil } from '@/util'

const Actions = {
  // AGD01 集計データ取得
  getAggregateDataFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .get(api.AGGREGATE_DATA, params)
      .then((response) => {
        //const arr = [responses[0].data, responses[1].data]
        const path = mutationsTypes.AGGREGATE_DATA_SET_AGGREGATE_DATA_LIST
        commit(path, response.data.data)
        const getData = getters.getAggregateDataFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        //console.log(error)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // 帳票出力
  getAggregateDataLedgerSheet: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.FX_RATE_COMBINATION_LIST)
      .get(api.AGGREGATE_DATA_CSV, params)
      .then((response) => {
        const path = mutationsTypes.LEDGER_SHEET_HEADER
        commit(path, response)
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
}

export default Actions
